// extracted by mini-css-extract-plugin
export default {"main":"Footer_main__P+zbc","content":"Footer_content__pG2T6","logo":"Footer_logo__W8CYG","email":"Footer_email__MQg1+","socialLink":"Footer_socialLink__BBSri"};